
export default {
  props: {
    images: {
      type: Array,
      required: false,
    },
    imagesXLarg: {
      type: Array,
      required: false,
    },
    videos: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      imageZoom: {
        startImgIndex: 0,
        isZooming: false,
      },
    };
  },
  computed: {
    coverVideo() {
      if (!this.videos) return null;
      return this.videos.find((v) => v.Cover);
    },
    coverVideoIndex() {
      if (!this.videos) return -1;
      return this.videos.findIndex((v) => v.Cover);
    },
    nonCoverVideos() {
      if (!this.videos) return [];
      return this.videos
        .map((v, i) => ({ ...v, originalIndex: i }))
        .filter((v) => !v.Cover);
    },
  },
  methods: {
    showZoom(i) {
      this.imageZoom.isZooming = true;
      this.imageZoom.startImgIndex = i;
    },
  },
};
